module.exports = __webpack_public_path__ + "static/media/artur-neto.5bea1140.png";